
import React from 'react';
import Navigation from '@/components/Navigation';
import ListingSearch from '@/components/listings/ListingSearch';
import Footer from '@/components/Footer';

const BrowseListings = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-background to-secondary/20">
      <Navigation />
      <div className="min-h-screen">
        <ListingSearch />
      </div>
      <Footer />
    </div>
  );
};

export default BrowseListings;
